import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SubscriptionWizardProvider } from '@/components/subscription-wizard/SubscriptionWizardContext';
import Step1Customer from '@/components/subscription-wizard/Step1Customer';
import Step1bOpportunity from '@/components/subscription-wizard/Step1bOpportunity';
import Step1cSubscriptionType from '@/components/subscription-wizard/Step1cSubscriptionType';
import Step2ChildCustomers from '@/components/subscription-wizard/Step2Tenant';
import Step3Contacts from '@/components/subscription-wizard/Step3Contacts';
import Step4Details from '@/components/subscription-wizard/Step4Details';
import Step5Plans from '@/components/subscription-wizard/Step5Plans';
import Step5bSplitConfig from '@/components/subscription-wizard/Step5bSplitConfig';
import Step6Summary from '@/components/subscription-wizard/Step6Summary';
import SubscriptionConfirmation from '@/components/subscription-wizard/SubscriptionConfirmation';
import { 
  CreditCard, 
  Sparkles, 
  ArrowLeft,
  Users
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const SubscriptionWizardPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      {/* Modern Header with Gradient Background */}
      <div className="relative overflow-hidden bg-gradient-to-r from-emerald-600 via-blue-600 to-indigo-700">
        <div className="absolute inset-0 bg-black/20" />
        <div className="absolute inset-0 bg-gradient-to-br from-white/5 via-transparent to-white/5" />
        
        <div className="relative container mx-auto px-6 py-6 pb-8">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
            <div className="space-y-2">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-white/20 backdrop-blur-sm rounded-lg">
                  <CreditCard className="h-6 w-6 text-white" />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <h1 className="text-2xl font-extrabold text-white">Nova Assinatura</h1>
                    <div className="flex items-center gap-1 px-2 py-1 bg-white/20 backdrop-blur-sm rounded-full">
                      <Sparkles className="h-3 w-3 text-yellow-300" />
                      <span className="text-xs text-white font-extrabold">Assistente</span>
                    </div>
                  </div>
                  <p className="text-blue-100 text-base pb-2">
                    Configure uma nova assinatura passo a passo de forma intuitiva
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <Button 
                variant="secondary" 
                size="default"
                onClick={() => navigate('/subscriptions')}
                className="backdrop-blur-sm bg-white/20 border-white/30 text-white hover:bg-white/30 transition-all duration-200"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Voltar para Assinaturas
              </Button>
              
              <Button 
                variant="secondary" 
                size="default"
                onClick={() => navigate('/customers')}
                className="backdrop-blur-sm bg-white/20 border-white/30 text-white hover:bg-white/30 transition-all duration-200"
              >
                <Users className="h-4 w-4 mr-2" />
                Gerenciar Clientes
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Content Wrapper */}
      <div className="relative z-10 -mt-4">
        <div className="container mx-auto px-6">
          <div className="bg-white/80 backdrop-blur-sm border-0 shadow-xl rounded-t-2xl min-h-[calc(100vh-200px)]">
            <div className="p-6">
              <SubscriptionWizardProvider>
                <Routes>
                  <Route path="step1" element={<Step1Customer />} />
                  <Route path="step1b" element={<Step1bOpportunity />} />
                  <Route path="step1c" element={<Step1cSubscriptionType />} />
                  <Route path="step2" element={<Step2ChildCustomers />} />
                  <Route path="step3" element={<Step3Contacts />} />
                  <Route path="step4" element={<Step4Details />} />
                  <Route path="step5" element={<Step5Plans />} />
                  <Route path="step5b" element={<Step5bSplitConfig />} />
                  <Route path="step6" element={<Step6Summary />} />
                  <Route path="confirmation/:id" element={<SubscriptionConfirmation />} />
                  <Route path="*" element={<Navigate to="step1" replace />} />
                </Routes>
              </SubscriptionWizardProvider>
            </div>
          </div>
        </div>
        
        {/* Bottom Spacing */}
        <div className="h-16" />
      </div>
    </div>
  );
};

export default SubscriptionWizardPage; 